//@flow

// Vendors
import React, { useEffect, useState, type Context } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { getPaymentAccounts } from '../../reducers/payment/paymentActions';
import { getAddresses } from '../../reducers/user/getAddresses/getAddressesActions';

// Helpers
import { scrollToTop, getPaymentRoute } from '../../lib/helpers';
import { selectPathname } from '../../reducers/route/routeSelectors';

// Components
import { LoadingDots, StepperWithRoutes } from '..';
import { steps, PAYMENT_STEPS } from './PaymentSteps';

// Styles
import './payment.scss';
import { replace } from 'connected-react-router';
import { TPWD_Transaction_Submitted_Modal } from '../common/modals';

type Props = {
  onSuccess: Function,
  onError: Function,
};

export type PaymentContextObject = { onSuccess?: Function, onError?: Function };

export const PaymentContext: Context<PaymentContextObject> = React.createContext(
  {}
);

const Payment = ({ onSuccess, onError }: Props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const currentPath = useSelector(selectPathname);

  useEffect(() => {
    Promise.all([
      dispatch(getPaymentAccounts()),
      dispatch(getAddresses()).catch(() => null),
    ])
      .then(([paymentAccounts]) => {
        setLoading(false);

        if (!paymentAccounts || (paymentAccounts && !paymentAccounts.length)) {
          dispatch(replace(getPaymentRoute('/form', currentPath)));
        }
      })
      .catch(() => {
        dispatch(replace('/dashboard'));
      });
  }, [dispatch]);

  return (
    <>
      <PaymentContext.Provider value={{ onSuccess, onError }}>
        <div className="payment">
          {loading ? (
            <LoadingDots />
          ) : (
            <StepperWithRoutes
              transition="SlideTransition"
              steps={steps}
              defaultStepId={PAYMENT_STEPS.SELECT_PAYMENT}
              onStepChange={scrollToTop}
            />
          )}
        </div>
      </PaymentContext.Provider>
      <TPWD_Transaction_Submitted_Modal />
    </>
  );
};

export default Payment;